import { render } from "./SqlPlayground.vue?vue&type=template&id=c14e1b66"
import script from "./SqlPlayground.vue?vue&type=script&lang=js"
export * from "./SqlPlayground.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__